import React from "react";
import Layout from "../Layout/Layout";
import PageTop from "../Layout/PageTop";
import { useParams } from "react-router-dom";
import { allServices } from "../../utils/AllServiceDetails";
import "./SingleServicePage.css";
import HomeContact from "../Layout/HomeContact";

const SingleServicePage = () => {
  const { ServiceName } = useParams();
  const fdRow = "row-reverse";
  const fdRowReve = "row";
  return (
    <Layout>
      <PageTop title={ServiceName} />
      <div className="SingleServicePageContainer">
        <h1 className="technitrust">Techni Trust</h1>
        {allServices
          .filter((item) => item.serviceName === ServiceName)
          .map((service) => (
            <div key={service.id}>
              <div className="serviceNameDetails">
                <h1>{service.serviceName}</h1>
                <span className="servicePara">{service.servicePara}</span>
              </div>
              <div className="ServicesCollectionWrapper">
                {service.items.map((list, index) => (
                  <div
                    className="HomeserviceCard-container"
                    style={{
                      flexDirection: (list.serviceId % 2 === 0) ? fdRow : fdRowReve
                    }}
                    key={list.serviceId}
                  >
                    <img className="servicecardImg" src={list.image} alt="" />
                    <div className="ServiceCardInfowrapper">
                      <span className="serviceCardName">{list.services}</span>
                      <span className="serviceCardPara">{list.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
      <HomeContact />
    </Layout>
  );
};

export default SingleServicePage;
